import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NfrpAlertMessage, NavigationStore, NfrpDefaultGridComponent, NfrpGridService } from 'nfrp-shared-angular';
import { Observable, combineLatest, Subscription, of } from 'rxjs';
import { switchMap, filter, tap } from 'rxjs/operators';
import { validationPatterns, alertMessages } from 'src/app/helpers/common-constants';
import { BinaryResponseEnum, UserRoleEnum, FeatureTypeIDEnum } from 'src/app/helpers/enum';
import { PasswordValidators, RESET_VALIDATION_PATTERNS } from 'src/app/helpers/password-validators';
import { LoginService } from 'src/app/services/login.service';
import { AssignedRoles } from '../../../model/assigned-roles';
import { EditRoles } from '../../../model/edit-roles';
import { UserInfo, UserResponse } from '../../../model/edit-user';
import { LoginUser } from '../../../model/login-user';
import { SearchUser } from '../../../model/search-user';
import { TpAdminData, TpadminSearch } from '../../../model/tpadmin-data';
import { SearchUsersStore } from '../../../search-users.store';
import { FooterFeaturesService } from '../../../services/footer-features.service';
import { SearchUsersService } from '../../../services/search-users.service';
import { Roles, UserRole } from '../../../model/role-admin';

@Component({
    selector: 'role-administration',
    styleUrls: ['./role-admininstration.component.css'],
    templateUrl: './role-admininstration.component.html',
    standalone: false
})
export class RoleAdministrationComponent extends NfrpDefaultGridComponent<Roles> implements OnInit, OnDestroy {
  @Output() loadEditUser: EventEmitter<string> = new EventEmitter<string>();
  numberOfItems: number;
  userEmail: string;
  roleId: string;
  formSubscription: Subscription;
  private subscriptions = [];
 
  constructor(
    nfrpGridService: NfrpGridService<Roles>,
    private searchUsersService: SearchUsersService,
    private footerFeaturesService: FooterFeaturesService,
    private router: Router
   ) {
    super(nfrpGridService);
  }
  
  ngOnInit(): void {
    window.scroll(0, 0);
    const loginUser = sessionStorage.getItem('loginUser');
    this.userEmail = loginUser ? JSON.parse(loginUser)?.userEmail : '';
    this.subscriptions.push(
      this.footerFeaturesService.getSubFooterDetails(FeatureTypeIDEnum.USER_MGMT, this.userEmail).subscribe()
    );
    this.getUserRoles();
  }

  getUserRoles() {
    this.subscriptions.push(
      this.searchUsersService.getUserRoles(this.userEmail).subscribe((response: any) => {
        const roles = Array.isArray(response?.roles) ? response.roles : [];
        this.dataSource = roles;
        this.numberOfItems = this.dataSource?.length;
        this.setupGrid();
        this.paginate({
          limit: 20,
          offset: 1,
        });
      }
    )
    );
  }

  userAdminRowClicked(roleData: UserRole) {
    this.roleId = roleData.userTypeId;
  //  this.router.navigate(['userMgmt/edit-role', this.roleId]);
    this.router.navigateByUrl('userMgmt/edit-role?roleId='+this.roleId+'&roleLabel='+roleData.userTypeLabel);
  }
 
  ngOnDestroy(): void {
    for (const subscriptions$ of this.subscriptions) {
      subscriptions$.unsubscribe();
    }
  }
 
}